import React from 'react';
import Grid from '@material-ui/core/Grid';
import { EFFECTIVE_DATE_LOCKED_HINT, EFFECTIVE_DATE_LOCKED_MESSAGE } from '@ourbranch/policy-utils';

import { Tooltip } from 'core/components/tooltip';
import useStyles from './locked-start-date-hint.styles';

/**
 * Why the Start Date can't be edited once the policy is effective (#36459), on its own line under the Policy Term
 * row. As the Start Date field's helper text it was squeezed under the narrow field (#37787).
 */
export function LockedStartDateHint() {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.hint}>
      {EFFECTIVE_DATE_LOCKED_HINT}
      <Tooltip text={EFFECTIVE_DATE_LOCKED_MESSAGE} placement="bottom" smallIcon={{}} />
    </Grid>
  );
}
